import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhoneRingingFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12.2 21.83c-2.27 0-4.61-1.38-6.97-4.09-2.38-2.74-3.41-5.27-3.07-7.53a5.056 5.056 0 0 1 1.97-3.33l.42-.37c.44-.38.91-.54 1.38-.47.79.11 1.36.84 1.76 1.47l.38.59c.35.55 1.43 2.23-.04 3.5l-.52.45c-.06.05-.14.11-.22.16-.24.16-.35.25-.37.42-.03.22.05.9 1.38 2.43 1.33 1.53 2 1.7 2.22 1.71.17 0 .28-.1.47-.31.07-.08.14-.15.19-.2l.52-.45c1.47-1.27 2.98.03 3.48.45l.53.45c.56.48 1.21 1.14 1.21 1.94 0 .48-.22.92-.66 1.3l-.47.41c-.38.4-1.58 1.43-3.52 1.45h-.06l-.01.02Z" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.74 2.81a.9.9 0 1 0 0 1.8 8.56 8.56 0 0 1 8.56 8.56.9.9 0 1 0 1.8 0c0-5.728-4.644-10.36-10.36-10.36Zm-.2 3.54a.9.9 0 1 0 0 1.8 5.216 5.216 0 0 1 5.21 5.21.9.9 0 1 0 1.8 0 7.016 7.016 0 0 0-7.01-7.01Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhoneRingingFilled
